import styled from 'styled-components';

const Container = styled.div`
  margin: 24px 40px;
  display: flex;
  justify-content: space-between;
`;

const TagRemove = styled.span`
	color: rgba(255,255,255,0.4);
	margin-left: 16px;
`;

const TagContainer = styled.button`
  background-color: #4A90E2;
  border: 0px;
  color: white;
  box-shadow: 0px 5px 20px -8px #4A90E2;
  border-radius: 4px;
  padding: 4px 8px 6px;
  position: relative;
  cursor: pointer;
	margin: 0 10px 0 0;
	display: inline-flex;
	align-items: center;
`;

const ListTypeContainer = styled.div`
  button:nth-child(1) {
		margin-right: 16px;
	}
`;

const Note = styled.label`
  opacity: 0.5;
  font-size: 12px;
  margin: 0px 8px;
  line-height: 24px;
  display: inline-block;
`;

export {
	Container,
	TagRemove,
	TagContainer,
	ListTypeContainer,
	Note,
}
